package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

/**
 * "Spell this word": the reverse of [WordSelectionContent] — instead of picking words from a
 * bank to build a translated phrase, the user picks glyph-block codes from [blocks] (correct
 * codes + distractors) to spell out [gardiner]'s Gardiner-code sequence, filled in order into
 * the [MdCWordSlots][com.shadowings.gero.presentation.component.MdCWordSlots] grid that
 * [gardiner] defines.
 */
data class WordSpellingContent @OptIn(ExperimentalUuidApi::class) constructor(
    val prompt: QuizText,
    val gardiner: String,
    val blocks: List<String>,
    val transliteration: String? = null,
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz {

    constructor(
        prompt: StringResource,
        promptArgs: List<Any> = emptyList(),
        gardiner: String,
        blocks: List<String>,
        transliteration: String? = null
    ) : this(
        prompt = QuizText.Resource(prompt, promptArgs),
        gardiner = gardiner,
        blocks = blocks,
        transliteration = transliteration
    )

    constructor(
        prompt: String,
        gardiner: String,
        blocks: List<String>,
        transliteration: String? = null
    ) : this(
        prompt = QuizText.Plain(prompt),
        gardiner = gardiner,
        blocks = blocks,
        transliteration = transliteration
    )
}
